export const getLineChartOptions = (
  title: string,
  lineColor: string,
  categories: number[],
  isLightMode: boolean,
  isShowDataLabel: boolean
) => {
  return {
    chart: {
      zoom: {
        enabled: true,
        type: 'x',
        autoScaleYaxis: true,
        autoScaleXaxis: true
      },
      toolbar: {
        autoSelected: 'zoom'
      },
      background: isLightMode ? '#fff' : '#383838'
    },
    stroke: {
      width: 2
    },
    grid: {
      borderColor: isLightMode ? '#e7e7e7' : '#777',
      row: {
        colors: [isLightMode ? '#e8e8e8' : '#777', 'transparent'],
        opacity: 0.5
      }
    },
    theme: {
      mode: isLightMode ? 'light' : 'dark'
    },
    markers: {
      size: 0
    },
    title: {
      text: title,
      style: {
        fontSize: 16,
        fontColor: isLightMode ? '#1F2937' : '#dfdfdf'
      }
    },
    plotOptions: {
      bar: {}
    },
    colors: [lineColor],
    dataLabels: {
      enabled: isShowDataLabel
    },
    tooltip: {
      followCursor: true
    },
    xaxis: {
      type: 'datetime',
      tooltip: { enabled: false },
      categories: categories,
      labels: {
        show: true,
        formatter: (timestamp: any) => {
          var date = new Date(timestamp)
          return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()
        },
        style: {
          colors: [isLightMode ? '#1F2937' : '#dfdfdf'],
          fontSize: 10
        }
      }
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          colors: [isLightMode ? '#1F2937' : '#dfdfdf'],
          fontSize: 14
        }
      }
    }
  }
}
